import React, { useState, useCallback, useMemo } from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { HEADER_H, HeaderSlotContext } from './headerSlot';
import { tokens } from '../../styles/tokens';

const DRAWER_WIDTH_EXPANDED = 260;
const DRAWER_WIDTH_COLLAPSED = tokens.sizes.railWidth;

const MainLayout = ({ children }) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
    const [headerSlot, setHeaderSlot] = useState(null);

    const handleDrawerToggle = useCallback(() => {
        setMobileOpen(prev => !prev);
    }, []);

    const handleSidebarCollapse = useCallback(() => {
        setSidebarCollapsed(prev => !prev);
    }, []);

    const currentWidth = useMemo(
        () => sidebarCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH_EXPANDED,
        [sidebarCollapsed]
    );

    // overflow: clip, not hidden/auto: neither box scrolls (the window does),
    // and a scroll container here would stop position: sticky working in the
    // pages below. Sideways only: content that spills out of a fixed-height
    // box (the cluster page's tab panel, maxHeight 70vh) must still extend
    // the page, or it is cut off with nothing to scroll.
    return (
        <HeaderSlotContext.Provider value={headerSlot}>
        <Box sx={{ display: 'flex', minHeight: '100vh', overflowX: 'clip' }}>
            <TopBar onDrawerToggle={handleDrawerToggle} slotRef={setHeaderSlot} />

            <Sidebar
                width={currentWidth}
                mobileOpen={mobileOpen}
                onDrawerToggle={handleDrawerToggle}
                collapsed={sidebarCollapsed}
                onCollapse={handleSidebarCollapse}
            />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    minHeight: '100vh',
                    backgroundColor: '#FAFBFC',
                    minWidth: 0,
                    overflowX: 'clip',
                    overflowY: 'visible',
                }}
            >
                <Box aria-hidden="true" sx={{ height: HEADER_H }} />
                {children}
            </Box>
        </Box>
        </HeaderSlotContext.Provider>
    );
};

export default MainLayout;
